module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAYAAAA6oTAqAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEoSURBVHgB7dnBTcNAEIXhNxv7nhJMBdABlEAJ5mLFRzoIFXB05AspxZRAB1sCBcAOGyuIXJdB8sOa75K9bJTflqydWGA0DEMjsnkGZAsD1Y+nvu8nGFQwCqG+UU33+efAIl+QmD8mGJhjUkpbkXk5hYA9CqnKnaru8QfMMRdi13WvKDQM49X5YpgFrIjHsPIYVh7DymNYeQyrVcVU9nkkNXkvGFT2eYQj5KRimkesLueZxecRK3+asfIYVh7Dal3HGfBoD4exxS+lpI+ruTMhyDXTnTnudt0DCuUTSJtPIC+ntT8AWHkMK49h5TGsPIaVx7DyGFYew8pjWMnP2Kkxt0UUm9/PNMvvxzH/B/AZgQ3OX9ig2PcrgGX3i8j7vBrH8Rb/XF3Xb1/UHFh5Kc2L8QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tabbar/rank.png
// module id = tR8m
// module chunks = 7